import React from 'react'
import { get } from 'lodash'
import api, { ILease } from '@api'
import { IconButton, Confirmation, Toaster } from '@ui'
import track from '@track'
import { ApolloError } from 'apollo-boost'

interface IProps {
  editing?: boolean
  dirty?: boolean
  lease?: ILease
  onEdit?: () => void
  onDelete?: () => void
  onClose: () => void
}

export default function QuickAcitons({ dirty, editing, lease, onEdit, onDelete, onClose }: IProps) {
  return (
    <div className="dialog-buttons">
      {!!onEdit && !editing && !!get(lease, 'id') && (
        <IconButton
          minimal
          data-button="edit_lease"
          tooltip="Edit"
          iconName="pen"
          onClick={onEdit}
        />
      )}
      {!!onDelete && !!lease && (
        <Confirmation
          text={<div style={{ width: 120 }}>Delete this lease?</div>}
          track={() =>
            track.lease({
              eventName: track.Event.DELETE_RECORD_DIALOG,
            })
          }
          onConfirm={() =>
            api.lease
              .remove(lease.id)
              .then(() => {
                onDelete()
                Toaster.success({ message: 'Lease deleted' })
              })
              .catch((error: ApolloError) => Toaster.fail({ error }))
          }
        >
          {!editing && <IconButton minimal tooltip="Delete" iconName="trash" />}
        </Confirmation>
      )}
      <Confirmation
        enabled={dirty}
        text={<div style={{ width: 180 }}>Discard unsaved changes?</div>}
        onConfirm={onClose}
      >
        <IconButton
          minimal
          tooltip="Close"
          iconName="times"
          onClick={() => {
            if (dirty) return
            onClose()
          }}
        />
      </Confirmation>
    </div>
  )
}
